export default __webpack_public_path__ + "static/N0143-cb5900d8ac8b1ffdc448dd1db9b05048.png";